import { formatDateWithDay } from "@/utils/schedule";

export default function ReservationDateViewer (props) {
  const {
    targetDate
  } = props

  return (
    <div className="flex items-center gap-3">
      <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center flex-shrink-0">
        <i className="ri-calendar-line text-blue-600 text-lg"></i>
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-base font-bold text-gray-900">{formatDateWithDay(targetDate)}</p>
        <p className="text-xs text-gray-500 mt-0.5">웨딩 업체 방문 예정일</p>
      </div>
    </div>
  )
}
